export default __webpack_public_path__ + "static/media/logo.6bf3f1a7.png";